import { render, staticRenderFns } from "./BannerHeader.vue?vue&type=template&id=22f567fa&"
import script from "./BannerHeader.vue?vue&type=script&lang=ts&"
export * from "./BannerHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports